module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-down-white-aad9b6ec764d9cf36007e4632657333c.png";